import {Component, Input} from "@angular/core";

@Component({
  selector: "admin-section-standard",
  templateUrl: "./standard.component.html",
  styleUrls: ["./standard.component.css"]
})
export class AdminSectionStandardComponent {
  @Input() title: string = "";
  @Input() border: string = "";
  @Input() customs: string = "";
}
